module.exports = __webpack_public_path__ + "img/cannon20_icon.2cf8f54e.png";